import React, { useRef } from "react";
import { message } from "antd";
import { IYhFormRef, FormItemTypeEnum, IYhForm } from "@/components/YhFormBox/Types";
import { getFormValidatorErrText } from "@/utils/utils";
import { YHDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { IKerwordsInsert } from "../keyWordsService";
import { useKeyWordsModel } from "../keyWordsModel";


export function KeyWordsDrawer() {
	const { keyWordsDrawer: { visible, mode }, selectedRowKeys, keyWordsTypeOptions, setKeyWordsDrawer, insertKeyWords, updataKeyWords } = useKeyWordsModel();
	const formRef = useRef<IYhFormRef>();

	const onCancel = () => {
		setKeyWordsDrawer({ visible: false, mode: "add" });
	}

	//表单提交
	const onSubmit = async () => {
		formRef.current?.validateFields().then((val: IKerwordsInsert) => {
			let data = {
				...val,
				keywordTypeName: keyWordsTypeOptions.find(item => item.value === val.keywordTypeId)?.label ?? "",
			}
			if (mode === "add") {
				insertKeyWords({
					...data,
					status: "1"
				})
			} else {
				let { id } = selectedRowKeys?.[0] ?? {};
				updataKeyWords({
					...data,
					id: id ?? ""
				})
			}
		}).catch(err => {
			message.warning(getFormValidatorErrText(err));
		})
	}



	const formConfig: IYhForm = {
		formRef,
		labelCol: { span: 6 },
		formValues: mode === "edit" ? selectedRowKeys?.[0] ?? {} : {},
		items: [
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "关键词名称",
				fieldName: "name",
				span: 24,
				rules: [{ required: true, message: "请输入分类名称" }]
			},
			{
				type: FormItemTypeEnum.Select,
				fieldLabel: "所属分类",
				fieldName: "keywordTypeId",
				span: 24,
				options: keyWordsTypeOptions,
				rules: [{ required: true, message: "请输入关键词分类" }]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "权重",
				fieldName: "weight",
				span: 24,
				rules: [{ required: true, message: "请输入权重" }]
			}
		]
	};
	return (
		<YHDrawer
			{...{
				title: `关键词${mode === "edit" ? "编辑" : "新增"}`,
				visible,
				onCancel,
				okText: "保存",
				onOk: onSubmit
			}}
		>
			<YhForm {...formConfig} />
		</YHDrawer>
	)
}
